import React, { useEffect, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import { createNotification } from '../../../utils/utils'
import LoaderSpinner from "../../../shared/components/LoaderSpinner/LoaderSpinner";
import { updateClienteHP, validateLocationHP } from '../../../helpers/Cliente.helper'
import "./styles.scss";
import { updateImages } from '../../../shared/utils'
import { login } from "../../../shared/redux/action/admin.actions";
import cities from '../../../shared/data/cities.json';
import { auth } from "firebase";
import { useCookies } from 'react-cookie';
import background from '../../../shared/media/background_profile.png';
import InputProfile from "../../../shared/atoms/input profile";
import Button from "../../../shared/atoms/button";

function MiPerfil({ history, state, dispatch }) {

  const [form, setForm] = useState(state.auth.user);
  const [showLoading, setShowLoading] = useState(false);
  const [alertState, updateAlertState] = useState(false);
  const [alertMessage, updateAlertMessage] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(['dataMensajeria']);
  const [miToken, setMiToken] = useState("");
  const typeIdentity = [{ value: 'CC', name: 'Cedula de Ciudadania' }, { value: 'CE', name: 'Cedula Extranjera' }]

  let autoComplete = {}
  let google = window.google
  const formRef = useRef(null);
  let options = {
    componentRestrictions: { country: 'CO' }
  }
  useEffect(() => {
    console.log("--MiPerfil.Component.useEffect-- ");
    initFields()
    changeAdress()
  }, []);

  const changeAdress = () => {
    let options = {
      componentRestrictions: { country: 'CO' }
    }
 
    let input = document.getElementById('addressLocation')
    autoComplete = new google.maps.places.Autocomplete(input, options)
    autoComplete.setFields(['address_components', 'geometry', 'name', 'place_id'])


  }

  const initFields = () => {
    console.log("--MiPerfil.Component.initFields-- ");

    formRef.current[0].value = state.auth.user.name === undefined ? '' : state.auth.user.name
    formRef.current[1].value = state.auth.user.lastname === undefined ? '' : state.auth.user.lastname
    formRef.current[2].value = state.auth.user.type_identification === undefined ? '' : state.auth.user.type_identification
    formRef.current[3].value = state.auth.user.identification === undefined ? '' : state.auth.user.identification
    formRef.current[4].value = state.auth.user.phone === undefined ? '' : state.auth.user.phone
    formRef.current[5].value = state.auth.user.phone_mobile === undefined ? '' : state.auth.user.phone_mobile
    formRef.current[6].value = state.auth.user.password === undefined ? '' : state.auth.user.password
    formRef.current[7].value = state.auth.user.email === undefined ? '' : state.auth.user.email
    formRef.current[8].value = state.auth.user.city === undefined ? '' : state.auth.user.city
    formRef.current[9].value = state.auth.user.address === undefined ? '' : state.auth.user.address
    //formRef.current[10].value = state.auth.user.img === undefined ? '' : state.auth.user.img
  }

  const showAlert = (message) => {
    console.log("--MiPerfil.Component.showAlert--")
    console.log("--MiPerfil.Component.showAlert-- message: ", message)
    updateAlertState(true)
    updateAlertMessage(message)
    setTimeout(() => {
      updateAlertState(false)
    }, 2000)
  }


  const apiUpdate = async (body) => {
    console.log("--MiPerfil.Component.apiUpdate-- ");
    console.log("--MiPerfil.Component.apiUpdate-- body: ", body);
    setMiToken(state.auth.token)
    try {
      const response = await updateClienteHP(body)
      console.log("--MiPerfil.Component.apiUpdate-- response: ", response);

      if (!response['db']) {
        createNotification('Ocurrió un error al guardar la información, inténtalo nuevamente', 'error')
        showAlert(response['message'])
      } else {
        console.log("MiPerfil.Component.apiUpdate response: ", response)
        createNotification('Datos guardados con éxito!!!', 'success')
        dispatch(login({ user: response['db'], token: response['db']['_id'] }));
      }
    } catch (error) {
      console.error("--MiPerfil.Component.apiUpdate-- error: ", error)
    }
  }

  const handleUpdate = useCallback(
    async event => {

      console.log("--MiPerfil.Component.handleUpdate-- ");
      console.log("--MiPerfil.Component.handleUpdate-- event.target.elements: ", event.target.elements);
      event.preventDefault()
      const place = autoComplete.getPlace();
      const { name, lastname, type_identification, identification, phone, email, password, img, phone_mobile, country, city, addressLocation, department } = event.target.elements
      setShowLoading(true)
      const urlImage = event.target.elements.img.files[0] ? await updateImages(state.auth.user._id, event.target.elements.img.files[0]) : null;
      let formData = {
        ...(name && { name: name.value }),
        ...(lastname && { lastname: lastname.value }),
        ...(type_identification && { type_identification: type_identification.value }),
        // ...(identification && {identification: identification.value}),
        ...(phone && { phone: phone.value }),
        ...(email && { email: email.value }),
        ...(password.value && { password: password.value }),
        ...(urlImage && { img: urlImage }),
        ...(place && {
          address: {
            nameLocation: place.name,
            addressLocation: place.name,
            lat: place.geometry && place.geometry.location.lat(),
            lng: place.geometry && place.geometry.location.lng()
          }
        }),
        ...(place && { addressLocation: place.name }),
        ...(phone_mobile && { phone_mobile: phone_mobile.value }),
        ...(country && { country: country.value }),
        ...(city && { city: city.value }),
        ...(department && { department: department.value }),
        _id: state.auth.user._id
      }
      console.log("--MiPerfil.Component.handleUpdate-- formData: ", formData);
      try {
        await apiUpdate(formData)
        setShowLoading(false)

      } catch (error) {
        console.error('--MiPerfil.Comoponent.handleUpdate-- error: ', error)
        setShowLoading(false)
      }

    }, []
  );

  const changeForm = (event) => {
    event.preventDefault()
    console.log(form);
    setForm({ ...form, [event.target.id]: event.target.value })

  }

  return (

    <>
      <form className="MiPerfil-Form" onSubmit={handleUpdate}
        ref={formRef}>
        <div className="MiPerfil-Form-panel">
          <h2>información personal</h2>
          <InputProfile name="name" label="Nombre" />
          <InputProfile name="lastname" label="Apellido" />
          <InputProfile className="select-profile" name="type_identification" label="Tipo de identificación" type="select" options={typeIdentity} />
          <InputProfile name="identification" label="Identificación" />
          <InputProfile name="phone" label="Telefono" type="number" />
          <InputProfile name="phone_mobile" label="Celular" type="number" />
          <InputProfile name="password" label="Contraseña" type="password" />
        </div>
        <div
          className="MiPerfil-Form-panel"
        >
          <InputProfile name="email" label="Email" type="email" />
          <InputProfile  className="select-profile" name="city" label="Ciudad" type="select" options={cities.data} />
          <InputProfile name="addressLocation" id= "addressLocation"
            value={form.addressLocation}
            onChange={changeForm}
            label="Dirección" />
          <InputProfile name="img" label="Imagen" type="file" />
          {alertState && (
            <div className="alert alert-danger mt-3 col-sm-3" role="alert">
              {alertMessage}
            </div>
          )}
          <Button name="Guardar" />
        </div>





      </form>
    </>
  )

}

export default withRouter(Connect(MiPerfil))